<template>
  <vs-popup
    @close='closeModal'
    title='Custom Fields'
    :active.sync='showModal'
  >
    <div>
      <ConfiguredCustomFields />
      <NewFields />
      <vs-row>
        <vs-col vs-lg='3' vs-sm='3' vs-xs='12' style='padding: 5px'>
          <vs-button color='danger' type='filled' @click='closeModal'>
            Cancel
          </vs-button>
        </vs-col>
        <vs-col vs-lg='3' vs-sm='3' vs-xs='12' style='padding: 5px'>
          <vs-button color='primary' type='filled' @click='postFields'>
            Save
          </vs-button>
        </vs-col>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
import ConfiguredCustomFields from './ConfiguredCustomFields';
import NewFields from './NewFields';
import { mapActions } from 'vuex';
import { preparePayload } from './utils';
import lastFulfilled from './mixins/lastFulfilled';

export default {
  name: 'CustomFieldsForm',
  components: {
    ConfiguredCustomFields,
    NewFields,
  },
  mixins: [lastFulfilled],
  props: {
    showModal: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    ...mapActions('customFields', ['getCustomFields', 'postCustomFields', 'clearNewFields']),
    closeModal () {
      this.$emit('close');
    },
    async postFields () {
      let newFields = this.$store.state.customFields.newFields;
      let updatedFields = this.$store.state.customFields.fields;

      if (this.lastFulfilled(newFields)) {
        let payload = preparePayload(newFields, updatedFields);
        let response = await this.postCustomFields(payload);
        this.$vs.notify({
          color: response.code == 200 ? 'success' : 'danger',
          title: response.code == 200 ? 'Success' : 'Error',
          text:
            response.code == 200
              ? 'Custom fields saved'
              : 'Could not save custom fields',
        });
        if (response.code == 200) {
          await this.getCustomFields();
          this.clearNewFields();
          this.closeModal();
        }
      }
    },
  },
};
</script>
